
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {Deprecated004} from './Deprecated004';

/**
 * Deprecated003 struct
 */
class Deprecated003 extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @constructor
   */
  constructor (parent = new Request()) {
    super()
    super.copy(parent)
  }

  /**
   * Copy struct (shallow copy)
   * @this {!Deprecated003}
   * @param {!Deprecated003} other Other struct
   * @returns {!Deprecated003} This struct
   */
  copy (other) {
    super.copy(other)
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!Deprecated003}
   * @returns {!Deprecated003} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new Deprecated003Model(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new Deprecated003Model(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!Deprecated003}
   * @param {!Deprecated003} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof Deprecated003)) {
      throw new TypeError('Instance of Deprecated003 is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!Deprecated003}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return Deprecated003.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!Deprecated003} other Object value
   * @returns {!Deprecated003} Created struct
   */
  static fromObject (other) {
    return new Deprecated003().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!Deprecated003}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return Deprecated003.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!Deprecated003}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4083
  }
}

export { Deprecated003 };

/**
 * Fast Binary Encoding Deprecated003 field model
 */
class FieldModelDeprecated003 extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelDeprecated003}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelDeprecated003}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelDeprecated003}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4
  }

  /**
   * Get the field extra size
   * @this {!FieldModelDeprecated003}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelDeprecated003}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelDeprecated003.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelDeprecated003}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4083
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelDeprecated003}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelDeprecated003}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelDeprecated003}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelDeprecated003}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelDeprecated003}
   * @param {!Deprecated003} fbeValue Default value, defaults is new Deprecated003()
   * @returns {!Deprecated003} Deprecated003 value
   */
  get (fbeValue = new Deprecated003()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelDeprecated003}
   * @param {!Deprecated003} fbeValue Deprecated003 value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelDeprecated003}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelDeprecated003}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelDeprecated003}
   * @param {!Deprecated003} fbeValue Deprecated003 value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelDeprecated003}
   * @param {Deprecated003} fbeValue Deprecated003 value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
  }
}

export { FieldModelDeprecated003 };

/**
 * Fast Binary Encoding Deprecated003 model
 */
class Deprecated003Model extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelDeprecated003(this.buffer, 4)
  }

  /**
   * Get the Deprecated003 model
   * @this {!Deprecated003Model}
   * @returns {!FieldModelDeprecated003} model Deprecated003 model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!Deprecated003Model}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!Deprecated003Model}
   * @returns {!number} Model type
   */
  get fbeType () {
    return Deprecated003Model.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!Deprecated003Model}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelDeprecated003.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!Deprecated003Model}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!Deprecated003Model}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!Deprecated003Model}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!Deprecated003Model}
   * @param {!Deprecated003} value Deprecated003 value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!Deprecated003Model}
   * @param {!Deprecated003} value Deprecated003 value, defaults is new Deprecated003()
   * @return {!object} Deserialized Deprecated003 value and its size
   */
  deserialize (value = new Deprecated003()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new Deprecated003(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new Deprecated003(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!Deprecated003Model}
   * @param {!number} prev Previous Deprecated003 model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { Deprecated003Model };
Deprecated003.__has_response = true;
Deprecated003.__response_class = Deprecated004;
